import React, { useState, useEffect } from 'react';
import { getServices } from '../../../services/api';
import LoadingSpinner from '../../common/LoadingSpinner';
import AlertMessage from '../../common/AlertMessage';
import '../BookingForm.css';

const ServiceSelection = ({ selectedServices = [], onServiceSelect, corporationId }) => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      if (!corporationId) {
        setError('Corporation ID is required. Please check your .env file and restart the development server.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError(null);
        const response = await getServices(corporationId);
        
        if (response.success && response.data?.services) {
          setServices(response.data.services);
        } else {
          setError('Failed to load services');
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Error loading services. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, [corporationId]);

  const handleServiceChange = (service, isChecked) => {
    if (onServiceSelect) {
      if (isChecked) {
        // Add service
        onServiceSelect(service);
      } else {
        // Remove service - we need to pass the service to remove
        // The parent will handle the toggle logic
        onServiceSelect(service);
      }
    }
  };

  const isServiceSelected = (serviceId) => {
    return selectedServices.some(service => service.id === serviceId);
  };

  if (loading) {
    return <LoadingSpinner className="my-4" />;
  }

  if (error) {
    return <AlertMessage variant="danger" message={error} />;
  }

  if (services.length === 0) {
    return (
      <AlertMessage 
        variant="info" 
        message="No services available at the moment." 
      />
    );
  }

  return (
    <div className="service-selection">
      <h6 className="mb-3">Select Service(s)</h6>
      <ul className="service-list">
        {services.map((service) => {
          const isSelected = isServiceSelected(service.id);
          
          return (
            <li 
              key={service.id} 
              className={`service-list-item ${isSelected ? 'selected' : ''}`}
              onClick={() => handleServiceChange(service, !isSelected)}
              style={{ cursor: 'pointer' }}
            >
              <input
                type="checkbox"
                className="service-checkbox"
                checked={isSelected}
                onChange={(e) => handleServiceChange(service, e.target.checked)}
                onClick={(e) => e.stopPropagation()}
                id={`service-${service.id}`}
              />
              <div className="service-info">
                <div>
                  <label 
                    htmlFor={`service-${service.id}`}
                    className="service-name"
                    style={{ cursor: 'pointer', margin: 0 }}
                    onClick={(e) => e.stopPropagation()}
                  >
                    {service.name}
                  </label>
                </div>
                <div className="service-details">
                  <span>{service.duration} min</span>
                  <span className="service-price">RM{service.price}</span>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ServiceSelection;
